import React, { Component } from "react";
import jquery from "jquery";
import '../../assets/js/chosen.jquery'

class Select2Multiple extends Component{

    state = {
        data: []
    }

    placeholder = "";
    keys = "";
    required = false;
    name = ""
    className = ""
    
    constructor(props){
        super();
        this.state.data = props.data==undefined ? [] : props.data;
        this.placeholder = props.placeholder;
        this.keys = props.keys;
        this.required = props.required;
        this.name = props.name==undefined ? props.keys : props.name;
        this.className = props.className===undefined ? "" : props.className;

    }

    componentDidUpdate(){
        jquery(this.refs['select2']).chosen({no_results_text:"Not found"}).trigger("chosen:updated");
    }

    updateSelect(newData){

        this.setState({
            data:newData
        })

    }

    componentDidMount(){

        let ele = jquery(this.refs['select2']);
        let pr = this.props;

        ele.chosen().on("change", function(){
            let vl = ele.chosen().val()
            pr.onSelect && pr.onSelect(vl)
        });
    }

    render(){

        return(

            <select multiple value={this.props.value} data-placeholder={this.placeholder} onChange={this.props.onSelect} ref='select2' key={this.name} name={this.name} required={this.required} className={`form-control ${this.className}`}>
                {this.state.data && this.state.data.map((item, i) =>(
                    <option key={item.id} value={item.id}>{item[this.keys]}</option>
                ))}
            </select>
            
        );
    }
};

export default Select2Multiple;